<template>
  <router-link
    :to="`/${$type.toLowerCase()}/news/${news.id}`"
    class="d-flex flex-column justify-content-between h-100"
  >
    <router-view @go-to="goTo"></router-view>
    <div>
      <img :src="news.bannerImageUrl" alt="" class="banner" />
      <h5 class="gray-900 mt-3 text-justify">{{ news.title }}</h5>
      <h6 class="desc gray-700 mt-2 text-justify">{{ newsLimit }}</h6>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-2">
      <div class="primary text-sm">#{{ news.tag.name }}</div>
      ادامه‌ی مطلب
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
  computed: {
    newsLimit() {
      if (this.news.text.length > 90) {
        return this.news.text.substring(0, 90) + "...";
      } else {
        return this.news.text;
      }
    },
  },
  methods: {
    goTo(item, routeName) {
      routeName = `${item.title}`;
      this.$emit("go-to", routeName);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  border-radius: 8px;
  height: 168px;
  width: 100%;
  object-fit: cover;
}
.desc {
  word-wrap: break-word;
}
</style>
